import store from '@/store'

// Global mixin for all editable input fields
// Will trigger an error message if rules are not satisfied
export const inputs = {
  methods: {
    isRequired: function (this:any, event:any, errorList:string[], field:string, type?:'number' | 'string') {
      if (errorList) {
        // If empty field or negative value, and field error does not exist
        if (!event || event === '' || (type === 'number' && event < 0)) {
          if (errorList.indexOf(field) < 0) {
            errorList.push(field)
          }
        } else {
          errorList.splice(errorList.indexOf(field), 1)
        }
      }
    }
  }
}

// Used for conditional rendering on touchscreen and non-touchscreen devices
declare global {
  interface Window {
    PointerEvent:any
    TouchEvent:any
  }
}
export const touchScreen = {
  methods: {
    detect () {
      let result = false
      if (window.PointerEvent && ('maxTouchPoints' in navigator)) {
        // if Pointer Events are supported, just check maxTouchPoints
        if (navigator.maxTouchPoints > 0) {
          result = true
        }
      } else {
        // no Pointer Events...
        if (window.matchMedia && window.matchMedia('(any-pointer:coarse)').matches) {
          // check for any-pointer:coarse which mostly means touchscreen
          result = true
        } else if (window.TouchEvent || ('ontouchstart' in window)) {
          // last resort - check for exposed touch events API / event handler
          result = true
        }
      }
      // console.log('Is a touchscreen', result)
      return result
    }
  }
}

// Debounce
const debounce_reg: { [key: string]: number } = {};
export function debounce(key: string, callback: () => void, duration?:number) {
	let timekey = new Date().getMilliseconds();
	debounce_reg[key] = timekey;
	window.setTimeout((tk: number) => {
		if (debounce_reg[key] == tk) {
			callback();
		}
	}, (duration || 200), timekey);
}

export function detectTouchScreen() {
  return touchScreen.methods.detect()
}

export const update = {
  data() {
    return {
      // refresh variables
      refreshing: false,
      registration: null,
      updateExists: false,
    }
  },
  created(this:any) {
    // Listen for our custom event from the SW registration
    document.addEventListener('swUpdated', this.updateAvailable, { once: true })
    // Prevent multiple refreshes
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (this.refreshing) return
      this.refreshing = true
      // Here the actual reload of the page occurs
      window.location.reload()
    })
  },
  methods: {
    // Store the SW registration so we can send it a message
    // We use `updateExists` to control whatever alert, toast, dialog, etc we want to use
    // To alert the user there is an update they need to refresh for
    updateAvailable(this:any, event:any) {
      this.registration = event.detail
      this.updateExists = true
      // Call immediately no user confirmation
      // this.refreshApp()
    },
    // Called when the user accepts the update
    refreshApp(this:any) {
      this.updateExists = false
      // Make sure we only send a 'skip waiting' message if the SW is waiting
      if (!this.registration || !this.registration.waiting) return
      // Send message to SW to skip the waiting and activate the new SW
      this.registration.waiting.postMessage({ type: 'SKIP_WAITING' })
    }
  }
}

